import { formatInTimeZone } from 'date-fns-tz';
import { SelectedSlot } from '@/types/slots';

export function SlotTime({ slot }: { slot: SelectedSlot | undefined }) {
  if (!slot || !slot.time_zone) return null;

  return (
    <div className="flex items-center gap-2">
      <div className="flex w-14 flex-col items-start overflow-hidden rounded-lg border">
        <p className="flex h-6 w-full items-center justify-center bg-primary text-center text-xs font-semibold text-background uppercase">
          {formatInTimeZone(slot.start_at, slot.time_zone, 'MMM')}
        </p>
        <p className="flex w-full items-center justify-center text-lg font-bold">
          {formatInTimeZone(slot.start_at, slot.time_zone, 'dd')}
        </p>
      </div>
      <div>
        <span>
          {formatInTimeZone(slot.start_at, slot.time_zone, 'EEEE, d MMMM')}
        </span>
        <p className="text-muted-foreground text-sm">
          {formatInTimeZone(slot.start_at, slot.time_zone, 'h:mm a')} -{' '}
          {formatInTimeZone(slot.end_at, slot.time_zone, 'h:mm a (zzz)')}
        </p>
      </div>
    </div>
  );
}
